import { AldapaMark } from '../brand/AldapaMark'
import type { ShopProduct } from '../../data/shop/products'

export function ProductVisual({product,className=''}:{product:ShopProduct;className?:string}){
  const image=product.images[0]
  return <div className={`shop-product-visual ${product.category==='hardware'?'is-hardware':''} ${className}`}>{image?<img src={image.src} alt={image.alt}/>:<div className="shop-product-visual__placeholder"><AldapaMark/><span>{product.category}</span><small>Product image in preparation</small></div>}</div>
}
